module.exports = __webpack_public_path__ + "img/red-2-squiggly-solid.acb139ea.svg";